import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Nav = ({
  hideInactive,
  messageType,
  includeInactive,
  onToggleMessageType,
  onToggleIncludeInactive
}) => (
  <div className="mb-15">
    <div>
      <label>Message Type</label>
    </div>

    <div className="btn-group">
      <label
        className={classNames("btn btn-default", {
          active: messageType === "E-Mail"
        })}
        tabIndex="0"
        role="button"
        onClick={() => {
          onToggleMessageType("E-Mail");
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onToggleMessageType("E-Mail");
          }
        }}
      >
        Email
      </label>
      <label
        className={classNames("btn btn-default", {
          active: messageType === "Text"
        })}
        tabIndex="0"
        role="button"
        onClick={() => {
          onToggleMessageType("Text");
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onToggleMessageType("Text");
          }
        }}
      >
        Text
      </label>
    </div>

    {hideInactive ? null : (
      <a
        className="btn btn-text pointer-hand pull-right"
        disabled={includeInactive ? "disabled" : ""}
        onClick={onToggleIncludeInactive}
        tabIndex="0"
        role="button"
        aria-disabled={includeInactive}
      >
        INCLUDE INACTIVE EMPLOYEES
      </a>
    )}
  </div>
);

Nav.propTypes = {
  hideInactive: PropTypes.bool,
  messageType: PropTypes.string,
  includeInactive: PropTypes.bool,
  onToggleMessageType: PropTypes.func,
  onToggleIncludeInactive: PropTypes.func
};

export default Nav;
